import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__16, CHEVRON_LEFT__16} from '@homeaway/svg-defs';

import './FlexibleDatesOptionIcon.less';

export default function FlexibleDatesOptionIcon({type, days}) {
    const markup = type === 'sub' ? CHEVRON_LEFT__16 : CHEVRON_RIGHT__16;
    const icon = <SVGIcon markup={markup} inline aria-hidden />;
    const isDouble = days > 1;

    return (
        <span className="FlexibleDatesOptionIcon__Container">
            <span className="FlexibleDatesOptionIcon">
                {isDouble ? (
                    <>
                        {icon}
                        {icon}
                    </>
                ) : (
                    icon
                )}
            </span>
        </span>
    );
}
